import { useState, useEffect, useCallback } from 'react';

export const useRouter = () => {
  // Initialize state from current hash or default to home
  const [route, setRoute] = useState(window.location.hash || '#/');

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#/');
    };

    window.addEventListener('hashchange', handleHashChange);
    
    // Clean up the event listener on component unmount
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const navigate = useCallback((path: string) => {
    // Only update if the path is different to prevent unnecessary re-renders
    if (window.location.hash !== path) {
      window.location.hash = path;
    }
  }, []);

  // Parse the route into more usable parts
  // Example: #/products/1 -> ['products', '1']
  const pathParts = route.substring(2).split('/');
  const page = pathParts[0] || 'home';
  const param = pathParts[1] || null;

  return { navigate, page, param };
};
